import { z } from 'zod';

export const CreatePrePurchaseItemSchema = z.object({
    product_variation_id: z.string(),
    product_name: z.string(),
    quantity: z.coerce
        .number()
        .min(1, 'Quantity must be at least 1')
        .optional(),
    purchase_price: z.coerce
        .number()
        .min(0, 'Purchase price must be at least 0')
        .optional(),
    wholesale_price: z.coerce
        .number()
        .min(0, 'Wholesale price must be at least 0')
        .optional(),
    retail_price: z.coerce
        .number()
        .min(0, 'Retail price must be at least 0')
        .optional(),
    expiration_date: z.coerce.date().nullable().optional(),
});

export type TCreatePrePurchaseItem = z.infer<
    typeof CreatePrePurchaseItemSchema
>;

export const CreatePrePurchaseFormSchema = z.object({
    note: z.string().optional().nullable(),
    supplier_id: z.string().optional().nullable(),
    supplier_name: z.string().optional().nullable(),
    items: z.array(CreatePrePurchaseItemSchema).optional(),
    current_selected_item: CreatePrePurchaseItemSchema.optional(),
    brand_id: z.string().optional().nullable(),
    brand_name: z.string().optional().nullable(),
    total_paid_amount: z.coerce
        .number()
        .min(0, 'Paid amount must be at least 0')
        .optional(),
});

export type TCreatePrePurchaseForm = z.infer<
    typeof CreatePrePurchaseFormSchema
>;

export const INITIAL_VALUES: Partial<TCreatePrePurchaseForm> = {
    note: '',
    current_selected_item: {
        wholesale_price: 0,
        retail_price: 0,
        purchase_price: 0,
        quantity: 0,
        product_name: '',
        product_variation_id: '',
        expiration_date: undefined,
    },
    brand_id: '',
    brand_name: '',
    supplier_id: '',
    supplier_name: '',
    total_paid_amount: 0,
    items: [],
};
